/** Formatting + urgency helpers used by dashboards + debtor profile. */

export const relativeTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  const now = new Date();
  const diffMs = now - d;
  const diffSec = Math.floor(diffMs / 1000);
  if (diffSec < 60) return `${Math.max(1, diffSec)}s ago`;
  const min = Math.floor(diffSec / 60);
  if (min < 60) return `${min}m ago`;
  const h = Math.floor(min / 60);
  if (h < 24) return `${h}h ago`;
  const day = Math.floor(h / 24);
  if (day === 1) return "yesterday";
  if (day < 7) return `${day}d ago`;
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
};

export const shortDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};

/**
 * Urgency classification used across the app.
 * Returns one of "past" | "critical" | "warning" | "info".
 */
export const urgencyOf = (daysUntil) => {
  if (daysUntil == null) return "info";
  if (daysUntil <= 0) return "past";
  if (daysUntil <= 30) return "critical";
  if (daysUntil <= 60) return "warning";
  return "info";
};

export const urgencyColor = (u) => {
  switch (u) {
    case "critical": return "#E74C3C";
    case "warning":  return "#F39C12";
    case "past":     return "#5A7A9A";
    default:         return "#A8B8D0";
  }
};

export const centsToUSD = (cents, opts = {}) => {
  const n = Number(cents || 0) / 100;
  return n.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: opts.decimals ?? 2,
    maximumFractionDigits: opts.decimals ?? 2,
  });
};
